/*=========================================================================================
  File Name: module-internal-mutations.js
  Description: Internal Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA Internal
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */

export default {};
